import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import styled, { css } from 'styled-components';
import { TextSkeleton } from '../text/index.skeleton.js';
import { TextButtonSkeleton } from '../text-button/index.skeleton.js';
import { HeadlineSkeleton } from '../headline/index.skeleton.js';
import { SYS_BLUR_BACKGROUND_300, SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_150, getMargins } from '@oneaudi/unified-web-alpha-common';
// TODO: multiple token missing
const StyledContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 24px;
`;
const StyledTextWrapper = styled.div `
  max-width: 800px;
`;
const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${SYS_BORDER_RADIUS_MD};
  ${(props) => css `
    background-color: ${props.theme.sys.color.surface.interactive.card.default
    .fill};
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.sys.color.surface.interactive.card.default.stroke};
  `}
  backdrop-filter: blur(${SYS_BLUR_BACKGROUND_300});
`;
export const ProductTileSkeleton = ({ 'data-testid': dataTestId, margin, className }) => (React.createElement(StyledContainer, { "data-testid": dataTestId, margin: margin, className: className },
    React.createElement(Skeleton, { variant: "oval", width: "100%", aspectRatio: "4/3" }),
    React.createElement(StyledContentContainer, null,
        React.createElement(StyledTextWrapper, null,
            React.createElement(HeadlineSkeleton, { margin: [0, 0, '4px', 0], order: "4" }),
            React.createElement(TextSkeleton, { width: "65%", order: "2", margin: [0, 0, '16px', 0] }),
            React.createElement(TextSkeleton, { width: "50%", order: "1", margin: [0, 0, '12px', 0] }),
            React.createElement(TextSkeleton, { width: "100", order: "2", margin: [0, 0, '18px', 0] })),
        React.createElement(TextButtonSkeleton, { width: "100%", margin: [0, 0, SYS_SPACE_FIXED_150, 0] }),
        React.createElement(TextButtonSkeleton, { width: "100%" }))));
//# sourceMappingURL=index.skeleton.js.map